// src/components/ui/Modal.tsx
import { useEffect, useRef } from "react";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};

export default function Modal({ open, onClose, title, children }: ModalProps) {
  const panelRef = useRef<HTMLDivElement>(null);

  // Fecha com ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  // Fecha ao clicar fora
  const onBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) onClose();
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] grid place-items-center bg-black/70 backdrop-blur-sm"
      onMouseDown={onBackdropClick}
      aria-modal="true"
      role="dialog"
      aria-labelledby="modal-title"
    >
      <div
        ref={panelRef}
        className="mx-4 w-full max-w-3xl rounded-2xl border border-white/10 bg-[#0B1625] text-white shadow-[0_0_40px_rgba(100,192,242,.12)]"
      >
        <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
          <h3 id="modal-title" className="text-lg font-semibold">
            {title}
          </h3>
          <button
            onClick={onClose}
            className="rounded-lg p-2 text-muted-foreground hover:text-white hover:bg-white/5 transition"
            aria-label="Fechar"
            title="Fechar"
          >
            ✕
          </button>
        </div>

        <div className="max-h-[70vh] overflow-y-auto px-5 py-5 text-sm leading-relaxed text-gray-200">
          {children}
        </div>

        <div className="flex justify-end gap-2 border-t border-white/10 px-5 py-4">
          <button
            onClick={onClose}
            className="rounded-xl px-4 py-2 text-sm font-medium text-white/90 hover:text-white hover:bg-white/5 transition"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
